const nh3Template = (newElement) => {
  let temp = {
    id: newElement.id,
    type: newElement.type,
    position: newElement.position,
    className: newElement.className,
    sourcePosition: newElement.sourcePosition,
    targetPosition: newElement.targetPosition,
    data: {
      id: newElement.data.id,
      UIid: newElement.id,
      type: newElement.data.type,
      name: newElement.data.label,
      color: newElement.data.color,
      label: newElement.data.label,
      isValidated: newElement.data.isValidated,
      reward_critical_path: true,
      CAPEX_nl_id: 1,
      OPEX_nl_id: 1,
      ramp_up_limit: 0.5,
      ramp_down_limit: 0.5,
      fast_restart_steps: 4,
      slow_restart_steps: 48,
      default_initial_status: 0.15,
      min_throttle: 0.5,
      shut_in_duration_threshold: 4,
      group: 'No group',
      elNumber: newElement.data.elNumber,
    },
    style: {
      backgroundColor: newElement.data.color,
    },
  };
  return temp;
};

export default nh3Template;
